import { render, staticRenderFns } from "./UploadTypeChooser.vue?vue&type=template&id=f34c668e&lang=pug&"
import script from "./UploadTypeChooser.vue?vue&type=script&lang=ts&"
export * from "./UploadTypeChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports